import A11yDialog from 'a11y-dialog';

export function searchDialog() {
  const search = document.querySelector('#header-search');
  const search_dialog = new A11yDialog(search);

  search_dialog.on('show', function () {
    const input = search.querySelector('.search-field');

    if (input) {
      // Remove inert first, then immediately focus the input
      search.removeAttribute("inert");
      input.focus({ preventScroll: true }); // preventScroll avoids jumpy behavior
    }
  });

  search_dialog.on('hide', function () {
    search.setAttribute('inert', ''); // Put inert back when closing
  });
}
